var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCrmGroup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.2 3.133a3.55 3.55 0 100 7.1 3.55 3.55 0 000-7.1zm0 1.1a2.45 2.45 0 110 4.9 2.45 2.45 0 010-4.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.176 9.193a.55.55 0 11.123 1.093c-2.577.29-4.588 2.25-4.905 4.69l-.015.129 6.26.038a.55.55 0 01-.006 1.1l-6.836-.04a.55.55 0 01-.547-.55c0-3.314 2.566-6.083 5.926-6.46zM5.5 4.185c-1.412 0-2.55 1.17-2.55 2.606a2.61 2.61 0 001.54 2.395l.166.066.457.165a.55.55 0 00.456-.997l-.082-.037-.458-.166A1.504 1.504 0 014.05 6.79c0-.835.653-1.506 1.45-1.506a.55.55 0 100-1.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.16 8.428A4.551 4.551 0 001.45 12.9c0 .273.2.5.46.543l.09.007h1.2a.55.55 0 00.09-1.093l-.09-.007h-.605l.001-.016a3.453 3.453 0 012.58-2.785l.186-.04a.55.55 0 00-.113-1.09l-.09.009zM13.2 12.5a2 2 0 110 4 2 2 0 010-4zm0 1.1a.9.9 0 100 1.8.9.9 0 000-1.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2 8.45a.55.55 0 01.09 1.093l-.09.007h-1.451L13.75 13c0 .273-.2.5-.46.543l-.09.007a.55.55 0 01-.543-.46L12.65 13V9c0-.273.2-.5.46-.543l.09-.007h2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2 10.45a.55.55 0 01.09 1.093l-.09.007h-2a.55.55 0 01-.09-1.093l.09-.007h2z"
  }))));
}

export default SvgCrmGroup;